import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
export default function Sliders() {

    const data = [
        { id: 1, img: "/images/home/banquet_.jpg", title: "GATHERING" },
        { id: 2, img: "/images/home/conference-hall_.jpg", title: "CONFERENCE HALL " },
        { id: 3, img: "/images/home/living-space_.jpg", title: "MODERN COMFORT" },
        { id: 4, img: "/images/home/front-view_.jpg", title: "REFINED ARRIVAL" },
        { id: 5, img: "/images/home/POOL-SIDE-DINING_.jpg", title: "POOL SIDE DINING" },
        // { id: 6, img: "images/familyroom1.JPG", title: "NEW OPENINGS" },
      ];
 
      
      const settings = {
        dots: false, // Dots indicators
        infinite: true, // Infinite scroll
        speed: 400,
        slidesToShow: 3, // 3 cards in one row
        slidesToScroll: 1, // Scroll by 1 card
        autoplay: false, // Auto scroll
        autoplaySpeed: 2000, // 2 sec per slide
        arrows: true, // Left/Right arrows
        responsive: [
          {
            breakpoint: 768, // Mobile screen
            settings: {
              slidesToShow: 1, // Show 1 card on mobile
            }
          },
        ]
      };
  return (
    <>
    <div className="carousel-container ">
     {/* <div className="col-12"> */}
     <Slider {...settings}>
        {data.map((item) => (
         <>
          <div key={item.id} className="card me-1">
            <img src={item.img} loading='lazy' alt={"V Hotel The Grnad Shoba-"+ item.title} title={`V Hotel The Grnad Shoba latest offer`} />
            
          </div>
          <div className='card-name'>
            <h3>{item.title}</h3>
            <Link to="/query" title='v hotel the grand shoba banquet-query'>QUERY &gt;</Link>
            </div>
         </>
        ))}
      </Slider>
     </div>
    {/* </div> */}
    </>
  )
}
